import { routes as dashboards } from "./views/dashboard";
import { routes as admin } from "./views/admin";
import { routes as connections } from "./views/connections";
import { routes as notices } from "./views/notices";
import { routes as calendar } from "./views/calendar";
import { routes as absences } from "./views/absences";
import { routes as financeinfo } from "./views/financial-info";
import { routes as emergencybordcast } from "./views/emergency-brodcast";
import { routes as emergencyContacts } from "./views/emergency-contacts";
import { routes as yearinfo } from "./views/year-info";
import { routes as docusign } from "./views/docusign";
import { routes as docusignboarder } from "./views/docusignboarder";
import { routes as docusignpk } from './views/docusignpk';
import { routes as docusignPK2K12 } from './views/docusignPK2K12';

import { routes as docusignpkkps } from './views/docusignpkkps';
import { routes as docusignPreschools } from './views/docusignPreschools';
import { routes as studentGoals } from './views/student-goals';

import { routes as places } from "./views/places";
import { routes as kla } from "./views/key-learning-area";
import { routes as students } from './views/students';
import { routes as parentDashboard } from './views/parent-dashboard';
import { routes as schoolPsychologyRequest} from './views/school-psychology-request'
import { routes as logMetrics } from './views/log-metrics'

export const routes = [
  ...dashboards,
  ...admin,
  ...connections,
  ...notices,
  ...calendar,
  ...absences,
  ...financeinfo,
  ...emergencybordcast,
  ...yearinfo,
  ...places,
  ...kla,
  ...parentDashboard,
  ...students,
  ...studentGoals,
  ...schoolPsychologyRequest,
  ...logMetrics,
  ...emergencyContacts
];

export const authRoutes = [...docusign, ...docusignpk, ...docusignpkkps, ...docusignPK2K12, ...docusignboarder, ...docusignPreschools];
